import { HandoverStatus } from '../../types/domain/handoverItem';

export const isHandoverStatus = (value: string): value is HandoverStatus => {
  return Object.values(HandoverStatus).includes(value as HandoverStatus);
};
